import React from 'react';

export default function CardsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M12.2787 8.11984C11.732 6.58653 10.2521 5.48755 8.51227 5.48755C6.30576 5.48755 4.51256 7.25776 4.51256 9.43599C4.51256 11.6142 6.30576 13.3844 8.51227 13.3844C10.2521 13.3844 11.732 12.2854 12.2787 10.7521H15.1785V13.3844H17.8449V10.7521H19.1782V8.11984H12.2787ZM8.51227 10.7521C7.77899 10.7521 7.17903 10.1599 7.17903 9.43599C7.17903 8.71211 7.77899 8.11984 8.51227 8.11984C9.24555 8.11984 9.84551 8.71211 9.84551 9.43599C9.84551 10.1599 9.24555 10.7521 8.51227 10.7521Z"
      />
      <path
        fill="currentColor"
        d="M2.25625 0.974976H21.4344C22.6866 0.974976 23.6906 1.97902 23.6906 3.23123V16.7687C23.6906 18.0209 22.6866 19.025 21.4344 19.025H2.25625C1.00405 19.025 0 18.0209 0 16.7687L0.0112923 3.23123C0.0112923 1.97902 1.00405 0.974976 2.25625 0.974976ZM21.4344 3.23123H2.25625V16.7687H21.4344V3.23123Z"
      />
    </svg>
  );
}
